import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconListNumbers32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconListNumbers32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8.986 5.258v7.259a1 1 0 1 1-2 0V7.762l-.935.211a1 1 0 1 1-.442-1.95l2.156-.489zM28 9a1 1 0 1 0 0-2H15a1 1 0 1 0 0 2zm0 10a1 1 0 1 0 0-2H15a1 1 0 1 0 0 2zm-1-6a1 1 0 0 1-1 1H15a1 1 0 1 1 0-2h11a1 1 0 0 1 1 1m-1 11a1 1 0 1 0 0-2H15a1 1 0 1 0 0 2zM6.842 18.119a1.39 1.39 0 0 1 1.135-.619c.17 0 .273.053.325.102.037.035.132.144.132.456 0 .67-.358 1.48-.996 2.338-.62.836-1.415 1.597-2.075 2.147a1 1 0 0 0 .64 1.768h4.105a1 1 0 0 0 0-2H8.461q.303-.348.583-.722c.73-.982 1.39-2.22 1.39-3.531 0-.773-.26-1.443-.765-1.915-.49-.46-1.114-.643-1.692-.643-1.386 0-2.362.834-2.813 1.531a1 1 0 0 0 1.678 1.088"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconListNumbers32);
